import React, {useState} from "react";
import "../assets/css/Footer.css";
import image from "../assets/img/logotipo.svg";
import insta from "../assets/img/insta-icon.svg";
import linkedin from "../assets/img/linkedin-icon.svg";
import ContactForm from "./ContactForm";
import ContactWorkForm from "./ContactWorkForm";

const FooterLink = ({ href, children }) => (
  <p>
    <a className="linkPage-footer" href={href}>
      {children}
    </a>
  </p>
);

const SocialIcon = ({ href, src, alt }) => (
  <a
    className="icone-footer"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={src} className="img-fluid" alt={alt} />
  </a>
);

const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);


  return (
    <footer className="footer">
      <div className="mx-5">
        <div className="row">
          <div className="col-md-5">
            <div className="d-flex flex-column align-items-start mobile-div">
              <img
                src={image}
                className="img-fluid logo-gao"
                alt="Logo Gao Technologia"
              />
              <p className="text-footer">© 2025 GaoTech</p>
              <p className="text-footer">Desenvolvimento De Software</p>
            </div>
          </div>
          <div className="col-md-3 d-block d-sm-none mt-3 mb-5">
            <div className="d-flex flex-column   gap-2    ">
              <div className="row justify-content-center">
                <SocialIcon
                    href="https://www.linkedin.com/company/gaotechoficial/"
                    src={linkedin}
                    alt="icone linkedin"
                />
                <SocialIcon
                    href="https://www.instagram.com/gaotech_/"
                    src={insta}
                    alt="icone instagram"
                />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="row d-flex justify-content-center aliggn-items-center">
              <div className="col-md-6">
                <div className="d-flex flex-column align-items-start gap-3  ">
                  <h2 className="title-footer">Navegação</h2>
                  <FooterLink href="#about">Sobre Nós</FooterLink>
                  <FooterLink href="#services">Produtos</FooterLink>
                  <FooterLink href="#certificate-products-history">
                    Nossa História
                  </FooterLink>
                  <FooterLink href="#testimonials">Depoimentos</FooterLink>
                  <a className="linkPage-footer" onClick={handleShow}>Trabalhe conosco</a>


                </div>
              </div>
              <div className="col-md-6 mt-5 mt-sm-0">
                <div className="d-flex flex-column align-items-start gap-3  ">
                  <h2 className="title-footer">Contato</h2>
                  <p>
                    <a
                      className="link-email"
                      href="mailto:contato@gaotech.com.br"
                    >
                      contato@gaotech.com.br
                    </a>
                  </p>
                  <p className="text-footer2 ">
                    Avenida Historiador Rubens de Mendonça, 1756, Sala 2505,
                    Andar 25, Edifício SB Tower, Bosque da Saúde, Cuiabá - MT,
                    CEP: 78.050-000
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 d-none d-sm-block">
            <div className="d-flex flex-column align-items-end gap-2 mobile-div">
              <div className="row justify-content-end">
                <SocialIcon
                  href="https://www.linkedin.com/company/gaotechoficial/"
                  src={linkedin}
                  alt="icone linkedin"
                />
                <SocialIcon
                  href="https://www.instagram.com/gaotech_/"
                  src={insta}
                  alt="icone instagram"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactWorkForm show={showModal} handleClose={handleClose} />
    </footer>
  );
};

export default Footer;
